import { h } from "preact";
import { useContext } from "preact/hooks";
import { SimpleReferralWidgetContext } from "../index";
import OfferTerms from "./OfferTerms";
import OfferView from "./OfferView";
import ShareView from "./ShareView";
import CashbackView from "./CashbackView";

const OfferViewPopup = props => {
  const simpleReferralWidgetContext = useContext(SimpleReferralWidgetContext);

  const renderPopupView = () => {
    if (
      simpleReferralWidgetContext.viewStateHistory.currentView.view ===
      "offer-view"
    )
      return <OfferView />;
    else if (
      simpleReferralWidgetContext.viewStateHistory.currentView.view ===
      "cashback-view"
    )
      return <CashbackView />;
    else if (
      simpleReferralWidgetContext.viewStateHistory.currentView.view ===
      "share-view"
    )
      return <ShareView />;
    else if (
      simpleReferralWidgetContext.viewStateHistory.currentView.view ===
      "offer-terms"
    )
      return <OfferTerms />;
  };

  return (
    <div
      id="corner-offer-view-popup-wrapper"
      className="corner-offer-view-popup-wrapper fixed top-0 right-0 w-full h-full flex justify-center items-center bg-black/50 z-50"
    >
      <div id="coca-offer-view-popup-card-wrapper">
        <div id="corner-thank-popup-close-btn" className=" flex justify-end ">
          <button
            className="text-base text-white mb-3 "
            onClick={() => simpleReferralWidgetContext.isPopupOpened.set(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 26 26"
              width="24px"
              height="24px"
              role="img"
              class="icon fill-current"
            >
              <path
                d="M8.28596 6.51819C7.7978 6.03003 7.00634 6.03003 6.51819 6.51819C6.03003 7.00634 6.03003 7.7978 6.51819 8.28596L11.2322 13L6.51819 17.714C6.03003 18.2022 6.03003 18.9937 6.51819 19.4818C7.00634 19.97 7.7978 19.97 8.28596 19.4818L13 14.7678L17.714 19.4818C18.2022 19.97 18.9937 19.97 19.4818 19.4818C19.97 18.9937 19.97 18.2022 19.4818 17.714L14.7678 13L19.4818 8.28596C19.97 7.7978 19.97 7.00634 19.4818 6.51819C18.9937 6.03003 18.2022 6.03003 17.714 6.51819L13 11.2322L8.28596 6.51819Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div
          id="coca-simple-offer-view-popup"
          className="coca-simple-offer-view-popup flex flex-col relative bg-white max-w-sm h-[575px] max-h-[85vh] rounded-lg overflow-hidden shadow-lg z-20 "
        >
          {renderPopupView()}
        </div>
      </div>
      <button
        onClick={() => simpleReferralWidgetContext.isPopupOpened.set(false)}
        className="coca-thank-popup-closer-bg fixed cursor-pointer opacity-0 top-0 right-0 w-screen h-screen z-10"
      />
    </div>
  );
};

export default OfferViewPopup;
